import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";

export const useOrder = create()(
  persist(
    (set) => ({
      order: {},
      transaccion_id: null,
      setOrder: (data) => {
        set(() => {
          return {
            order: data,
          };
        });
      },
      setTransaccion: (id = null) => set({ transaccion_id: id }),
    }),
    {
      name: "order-storage",// name of the item in the storage (must be unique)
      storage: createJSONStorage(() => sessionStorage),// 'localStorage','sessionStorage' is used 
    }
  )
);